import '@configs/mockDateForE2ETests';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { isAxiosNetworkErrorInSentry } from '@configs/sentry/isAxiosNetworkErrorInSentry';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './configs/i18n/i18n.config';
import './index.css';

if (import.meta.env.REACT_APP_SENTRY_ENABLED) {
  Sentry.init({
    dsn: `${import.meta.env.REACT_APP_SENTRY_DSN}`,
    integrations: [browserTracingIntegration()],
    environment: import.meta.env.REACT_APP_ENVIRONMENT,
    beforeSend: (event, hint) => {
      if (hint && isAxiosNetworkErrorInSentry(event, hint)) {
        return null;
      }
      return event;
    },
  });
}

// ReactDOM.render(<App/>, document.getElementById('root')
// );

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
// If you want to start measuring performance in your app, pass a function
// to log projections (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
